// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase : {
    apiKey: "AIzaSyDnEMtuItL48n5Iy7bFUocVQdKg6uIX2lk",
    authDomain: "hobbymatecentral.firebaseapp.com",
    databaseURL: "https://hobbymatecentral.firebaseio.com",
    projectId: "hobbymatecentral",
    storageBucket: "hobbymatecentral.appspot.com",
    messagingSenderId: "664234614690"
  }
};



// WEBPACK FOOTER //
// /Applications/WebStorm.app/Contents/bin/untitled3/Users/vidhyasagar/WebstormProjects/RealTimeAnalytics/CoinMachine/src/environments/environment.ts